import { render } from "./TheNotice.vue?vue&type=template&id=38b4169a&ts=true"
import script from "./TheNotice.vue?vue&type=script&lang=ts"
export * from "./TheNotice.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__